// import ApiPage from 'types/api/Page';
// import { ApiResources } from 'types/apiResources';
import { Endpoints } from 'types/endpoints';

import Page from 'models/Page';

import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface CreateParams {
    name: string;
    vatId: string;
    city: string;
    postCode: string;
    street: string;
    homeNo: string;
    flatNo: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}
export const create = async (params: CreateParams): Promise<Page> => {
    const response = await request({
        method: 'POST',
        path: withVariables(Endpoints.PublicCompanyRegister, params),
        requestParams: params,
    });

    // const data = response?.payload?.data;
    // const resource: ApiPage = data && data[ApiResources.Page];

    // if(!data || !resource) {
    //     return null;
    // }

    return response;
};
